"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.parse-int");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));
/* tslint:disable */


exports["default"] = function (_a) {
  var _b = _a.width,
      width = _b === void 0 ? '10px' : _b,
      _c = _a.height,
      height = _c === void 0 ? '10px' : _c,
      _d = _a.color,
      color = _d === void 0 ? '#000' : _d,
      _e = _a.bgColor,
      bgColor = _e === void 0 ? '#FFF' : _e,
      rest = __rest(_a, ["width", "height", "color", "bgColor"]);

  return react_1["default"].createElement("svg", __assign({}, rest, {
    width: width,
    height: height,
    viewBox: "0 0 " + Number.parseInt(width) + " " + Number.parseInt(height)
  }), react_1["default"].createElement("g", {
    stroke: 'none',
    fill: 'none',
    strokeWidth: '1',
    fillRule: 'evenodd'
  }, react_1["default"].createElement("g", {
    transform: 'translate(-622.000000, -17.000000)',
    fill: '#FFFFFF',
    fillRule: 'nonzero'
  }, react_1["default"].createElement("g", {
    transform: 'translate(528.000000, 13.000000)'
  }, react_1["default"].createElement("g", {
    transform: 'translate(94.000000, 4.000000)'
  }, react_1["default"].createElement("path", {
    d: 'M0.735000037,0 C0.622315956,0 0.516354676,0.0294129248 0.421093771,0.0769739743 L4.70476586,4.46006626 C4.79493199,4.5523754 5.0050685,4.5523754 5.09523463,4.46006626 L9.37890623,0.0769739743 C9.28364532,0.0294129248 9.17768404,0 9.06499996,0 L0.735000037,0 Z M0.0727343786,0.445601274 C0.0277903514,0.546414107 0,0.658543591 0,0.77777677 L0,6.22222323 C0,6.65311156 0.327808791,7 0.735000037,7 L9.06499996,7 C9.47219121,7 9.8,6.65311156 9.8,6.22222323 L9.8,0.77777677 C9.8,0.658543591 9.77220965,0.546414107 9.72726562,0.445601274 L5.4397659,4.83275096 C5.14091611,5.13872834 4.65908438,5.13872834 4.36023459,4.83275096 L0.0727343786,0.445601274 Z'
  }))))));
};
/* tslint:enable */